import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "../../../components/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export function GameLaunch() {
  const navigate = useNavigate();
  const location = useLocation();
  const gameLaunchUrl = location.state?.launchUrl as string | null;

  const handleClose = () => {
    if (location.state?.redirectTo) {
      navigate(location.state.redirectTo);
    } else {
      navigate("/casino");
    }
  };

  if (!gameLaunchUrl) {
    if (location.state?.redirectTo) {
      navigate(location.state.redirectTo);
    } else {
      navigate("/casino");
    }
    return null;
  }

  return (
    <div className="fixed inset-0 z-[999] bg-black flex flex-col">
      <div className="relative flex justify-end px-2 py-2 bg-black">
        <Button
          onClick={handleClose}
          className="bg-gray-800 text-white p-1.5 rounded-full hover:bg-gray-700"
        >
          <FontAwesomeIcon icon={faXmark} size="xs" />
        </Button>
      </div>
      <iframe
        src={gameLaunchUrl}
        title="Casino"
        className="w-full h-full border-0"
        allow="fullscreen; autoplay; encrypted-media"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </div>
  );
}
